import React, { useState, useCallback } from 'react';
import { Provider } from 'react-redux';
import * as LX from '@utils/lxWrapper';
import '@roo/roo/theme/default/index.css';
import '@assets/scss/base.scss';
import { isInOldApp, isInOldApp4 } from '@utils/getEnv';
// 诈骗提醒模态框相关组件和样式
import Modal from '@roo/roo/Modal';
import './blink.css';
// import reportPageLoadSuccessToPCClient from '@utils/reportPageLoadSuccessToPCClient';
import { BUSINESS_DATA_TYPE, reportBusinessData } from '@utils/report/commonReport';
import '../../assets/styles/normalize.css';
import generateDomPathForElement from '@utils/generateDomPathForElement';
import * as LLog from '@utils/llogWrapper';
import AfterSaleAuditRemind from '@shell/modules/AfterSaleAuditRemind';
import SaveOrderOperations from '@shell/modules/SaveOrderOperations';
import styles from './index.module.scss';
import store from './store';

import Header from './components/Header';
import LeftMenu from './components/LeftMenu';
import MainContent from './components/MainContent';
import OldVersionAlert from './components/OldVersionAlert';
import OrderNotificationBox from './components/OrderNotificationBox';
import WeakNotificationBox from './components/WeakNotificationBox';
import StrongNotificationBox from './components/StrongNotificationBox';
import TimerInfoRemindModal from './components/TimerInfoRemindModal';
import imInit from './modules/Im';
import customerServiceInit from './modules/CustomerService';
import freeChangeRemind from './modules/FreeChangeRemaind';
import freeChangeUnifiedRemaind from './modules/FreeChangeUnifiedRemaind';
import phfCombineOrder from './modules/PhfCombineOrder';
import orderAutoCompleteTipsRemind from './modules/orderAutoCompleteTipsRemind';
import CancelOrderRulesRemind from './modules/CancelOrderRulesRemind';

// import productManageRecommendGoodsTrack from './modules/productManageRecommendGoodsTrack';

import CompensateProtocolModal from './components/CompensateProtocolModal';
import initBackendDataConnection from './connection';
import bindBridgeMessageListener from './utils/bridgePlatform';
import observerLongTask from './utils/longTask';
import { getFrameByName, FRAME_NAME } from './utils/subFrames';

window.addEventListener('hashchange', () => {
    const hash = window.location.hash ? window.location.hash.substr(1) : '';
    store.dispatch({ type: 'mainContent/setShellHash', payload: hash });
    LLog.info({ to: hash }, LLog.REPORT_TAG_TYPE.PAGE_JUMP);
});
// eslint-disable-next-line
function isElement(value: any): value is Element {
    try {
        return value instanceof Element; // eslint-disable-line
    } catch (e) {
        return false;
    }
}
const clickEventHandler = function(e: Event) {
    const target = e.target;
    if (isElement(target)) {
        let domPath = '';

        try {
            domPath = generateDomPathForElement(target);
        } catch (err) {
            // Do nothing here
        }
        if (domPath !== '') {
            LLog.info(domPath, LLog.REPORT_TAG_TYPE.DOM_CLICK);
        }
    }
};
try {
    window.document.addEventListener('click', clickEventHandler, true);
} catch (e) {
    // BOOM
}
// try {
//     window.addEventListener('message', (e:MessageEvent) => {
//         console.log('透传消息log============', e.data)
//     })
// } catch (e) {
//     console.log('获取透传消息失败')
// }

const { useEffect } = React;
const Shell: React.FC = () => {
    const [suspectVisible, setSuspectVisible] = useState(false); // 诈骗提示模态框
    const [noticeButtonText, setButtonText] = useState('我知道了');
    const [noticeButtonCount, setButtonCount] = useState(10);
    const [noticeButtonDisable, setButtonDisable] = useState(true);
    const [dangerModalData, setNoticeModalData] = useState({
        title: '[高危风险] 疑似欺诈行为',
        content: '用户疑似存在欺诈行为，请勿支付钱款、扫码、添加微信/QQ/钉钉，谨防上当受骗！！',
        buttonText: '',
        countdown: 5,
    });
    const closeNoticeModal = () => {
        setSuspectVisible(false);
    };
    useEffect(() => {
        /** im iframe初始化 */
        imInit();
        /** 智能客服初始化 */
        customerServiceInit(store);
        /** 费率 2.0 换签提醒弹窗 */
        freeChangeRemind();
        /** 费率 2.0 【统一换签】弹窗 */
        freeChangeUnifiedRemaind();
        /** 订单系统完单优化新功能引导 */
        orderAutoCompleteTipsRemind();
        //https://km.sankuai.com/collabpage/2091184287 大纠纷，商家售后考核引导框
        AfterSaleAuditRemind();
        /**大纠纷商家取消订单费用规则调整 https://km.sankuai.com/collabpage/2250892250#b-5ab2f63616244833aaf5e97837fc6907 */
        CancelOrderRulesRemind();
        /** 拼好饭拼单一起送提醒 */
        phfCombineOrder();
        /** 轮询/push通道初始化 */
        initBackendDataConnection();
        /** 监听 iframe 发来的桥请求 */
        bindBridgeMessageListener();
        /** 首页客户端XP系统使用商家升级引导 */

        /** 上报页面正常（上报到PC客户端）*/
        // reportPageLoadSuccessToPCClient();
        /** 监听页面长任务 */
        observerLongTask();
        /** 【拓供给】推荐商品埋点优化  PM改为要求在Q2初再开启，临时屏蔽 */
        // productManageRecommendGoodsTrack();

        LX.reportPV('c_waimai_e_fa4ps4ng', { des: '首页外层' });
        LX.reportMV('b_waimai_e_uwl2admq_mv', 'c_waimai_e_fa4ps4ng');
        // 实时上报
        reportBusinessData(BUSINESS_DATA_TYPE.NEW_SHELL, {
            userAgent: window.navigator.userAgent,
        });
    }, []);
    useEffect(() => {
        let timerId: number;
        if (suspectVisible) {
            setButtonText(`${dangerModalData.buttonText}(${noticeButtonCount})`);
            if (noticeButtonCount <= 0) {
                setButtonDisable(false);
                setButtonText(dangerModalData.buttonText);
            } else {
                // 设置计时器
                timerId = window.setInterval(() => {
                    setButtonCount(prevCount => prevCount - 1);
                }, 1000);
                // eslint-disable-next-line consistent-return
            }
        }
        return () => {
            window.clearInterval(timerId);
        };
    }, [dangerModalData.buttonText, noticeButtonCount, suspectVisible]);

    // 处理来自IM的诈骗透传消息
    const imNoticeMessage = useCallback(
        (e: MessageEvent) => {
            if (!!e.source && (e.source === getFrameByName(FRAME_NAME.IM) || e.source === window)) {
                const data = e.data;
                let parsedData: any = {};
                try {
                    parsedData = JSON.parse(data);
                    if (
                        parsedData.type === 'SUSPECT_FRAUD' &&
                        parsedData.modalData &&
                        parsedData.modalData.title &&
                        parsedData.modalData.content &&
                        parsedData.modalData.countdown &&
                        parsedData.modalData.buttonText
                    ) {
                        setNoticeModalData(parsedData.modalData);
                        setButtonCount(parsedData.modalData.countdown);
                        setButtonDisable(true);
                        setSuspectVisible(true);
                    }
                } catch {
                    // console.log('JSON解析失败')
                }
            }
        },
        [setNoticeModalData, setSuspectVisible, setButtonCount],
    );
    useEffect(() => {
        // 注册监听事件
        window.addEventListener('message', imNoticeMessage);
        return () => {
            window.removeEventListener('message', imNoticeMessage);
        };
    }, [imNoticeMessage]);
    return (
        <Provider store={store}>
            {/* 非SLA商家7折赔付留痕弹框 */}
            <CompensateProtocolModal />
            {/*  */}
            <TimerInfoRemindModal token="d7e83b85-ea38-4368-9fa2-55f56c0dccd8" />

            {/* 客户端XP系统使用商家升级引导 */}
            {isInOldApp || isInOldApp4 ? <OldVersionAlert /> : null}

            <div className={styles.wrapper}>
                <Header />
                <div className={styles.contentWrapper}>
                    <LeftMenu />
                    <MainContent />
                </div>
                <div className={styles.weakNotificationWrapper}>
                    <OrderNotificationBox />
                    <WeakNotificationBox />
                </div>
                <StrongNotificationBox />
            </div>
            <div>
                <Modal
                    title={dangerModalData.title}
                    visible={suspectVisible}
                    className="danger-notice-modal"
                    closable={false}
                    backdropClosable={false}
                    showCancelButton={false}
                    confirmText={noticeButtonText}
                    confirmButtonProps={{ disabled: noticeButtonDisable }}
                    onConfirm={closeNoticeModal}
                >
                    <div className="danger-notice-content">{dangerModalData.content}</div>
                </Modal>
            </div>
            <SaveOrderOperations />
        </Provider>
    );
};

export default Shell;
